var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeShowedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#99F6E0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "See"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st0",
    d: "M12,15.1c1,0,1.9-0.4,2.6-1.1c0.7-0.7,1.1-1.6,1.1-2.6s-0.4-1.9-1.1-2.6C13.9,8.2,13,7.8,12,7.8 c-1,0-1.9,0.4-2.6,1.1c-0.7,0.7-1.1,1.6-1.1,2.6s0.4,1.9,1.1,2.6C10.1,14.8,11,15.1,12,15.1z M12,14.2c-0.8,0-1.4-0.3-1.9-0.8 c-0.5-0.5-0.8-1.2-0.8-1.9s0.3-1.4,0.8-1.9c0.5-0.5,1.2-0.8,1.9-0.8s1.4,0.3,1.9,0.8c0.5,0.5,0.8,1.2,0.8,1.9s-0.3,1.4-0.8,1.9 C13.4,13.9,12.8,14.2,12,14.2z M12,18c-2.2,0-4.1-0.6-5.9-1.8c-1.8-1.2-3.1-2.8-4-4.7c0.9-2,2.2-3.6,4-4.7C7.9,5.6,9.8,5,12,5 c2.2,0,4.1,0.6,5.9,1.8c1.8,1.2,3.1,2.8,4,4.7c-0.9,2-2.2,3.6-4,4.7C16.1,17.4,14.2,18,12,18z M12,17c1.9,0,3.6-0.5,5.2-1.5 c1.6-1,2.8-2.3,3.6-4c-0.8-1.7-2-3-3.6-4C15.6,6.5,13.9,6,12,6c-1.9,0-3.6,0.5-5.2,1.5c-1.6,1-2.8,2.3-3.6,4c0.8,1.7,2,3,3.6,4 C8.4,16.5,10.1,17,12,17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShowedIcon);
export default __webpack_public_path__ + "static/media/eye-showed-icon.952079c98dc5ba7a0c09eca7ec0f3675.svg";
export { ForwardRef as ReactComponent };